import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import UserContext from '../../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';
import displayError from '../../utils/ErrorHandler';

const AddLogisticsUser = () => {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: '', its: '', username: '', password: '' });
  const [notification, setNotification] = useState({ message: '', type: '' });

  useEffect(() => {
    async function startup() {
      if (!user) await authenticate(setUser, navigate);
    }
    startup();
  }, [user, navigate, setUser]);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const submitData = (e) => {
    e.preventDefault();
    const payload = {
      username: formData.username,
      password: formData.password,
      name: formData.name,
      role: 'Logistics',
      its: formData.its,
      zone: {}
    };

    axios
      .post(`${process.env.REACT_APP_API_URI}/api/users/register`, payload, { withCredentials: true })
      .then((response) => {
        setNotification({ message: 'Logistics user created successfully!', type: 'success' });
        setFormData({ name: '', its: '', username: '', password: '' });
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch((err) => {
        const errorMessage = displayError(err, navigate, setUser);
        if (errorMessage) {
          setNotification({ message: errorMessage, type: 'error' });
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
  };

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-4 lg:px-8">
      <h2 className="text-xl font-semibold text-fmb mb-4">Add Logistics User</h2>

      {notification.message && (
        <div
          className={`m-2 mb-4 p-4 rounded ${
            notification.type === 'success'
              ? 'bg-green-200 border-green-600 text-green-600'
              : 'bg-red-200 border-red-600 text-red-600'
          }`}
        >
          {notification.message}
        </div>
      )}

      <form className="space-y-6" onSubmit={submitData}>
        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">Full Name</label>
          <div className="mt-2">
            <input
              name="name"
              type="text"
              placeholder="Full name"
              value={formData.name}
              onChange={handleChange}
              required
              className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">ITS</label>
          <div className="mt-2">
            <input
              name="its"
              type="text"
              placeholder="ITS number"
              value={formData.its}
              onChange={handleChange}
              className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">Username</label>
          <div className="mt-2">
            <input
              name="username"
              type="text"
              placeholder="Username"
              value={formData.username}
              onChange={handleChange}
              required
              className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium leading-6 text-gray-900">Password</label>
          <div className="mt-2">
            <input
              name="password"
              type="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
              className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>

        <button
          type="submit"
          className="flex w-full justify-center rounded-full text-white bg-fmb px-3 py-3 text-sm font-semibold leading-6 shadow-sm hover:bg-indigo-500"
        >
          CREATE LOGISTICS USER
        </button>
      </form>
    </div>
  );
};

export default AddLogisticsUser;
